import { AvatarComponentProps } from '../Avatar';

export const ShirtStripes = (props: AvatarComponentProps) => {
  return (
    <svg
      width="190"
      height="190"
      viewBox="0 0 190 190"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      style={{ ...props.style }}
    >
      <path
        d="M23.0001 179H167C167 142 160 139 145 129.5L118 114.5C115.5 121.5 102.8 136.5 94.0001 136.5C85.2001 136.5 73.0001 123 72.5001 114.5C69.5001 116 73.1001 116.7 47.5001 129.5C21.9001 142.3 23.0001 161.5 23.0001 179Z"
        fill={props.colours![0]}
      />
      <path
        d="M42 155C42 149.477 46.4772 145 52 145H57V179H42V155Z"
        fill={props.colours![1]}
      />
      <rect x="57" y="145" width="15" height="34" fill={props.colours![0]} />
      <rect x="72" y="145" width="15" height="34" fill={props.colours![1]} />
      <rect x="87" y="145" width="15" height="34" fill={props.colours![0]} />
      <rect x="102" y="145" width="15" height="34" fill={props.colours![1]} />
      <rect x="117" y="145" width="15" height="34" fill={props.colours![0]} />
      <path
        d="M132 145H137C142.523 145 147 149.477 147 155V179H132V145Z"
        fill={props.colours![1]}
      />
    </svg>
  );
};
